<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<div class="grid align-items-center">
  <div class="col md:col-9">
    <span class="p-input-icon-left ml-auto w-full">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        #keywordFilter
        (input)="dt1.filterGlobal([keywordFilter.value], '')"
        placeholder="Cerca..." />
    </span>
  </div>
</div>

<div class="tbl max-w-full">
  <p-table
    [value]="users"
    [scrollable]="true"
    scrollHeight="400px"
    dataKey="id"
    #dt1
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [lazy]="true"
    [loading]="loading"
    (onLazyLoad)="loadUsers($event)"
    [totalRecords]="totalRecords"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th>Nome</th>
        <th>Username</th>
        <th>Email</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-u>
      <tr>
        <td>
          <p-radioButton
            [value]="u"
            [inputId]="u.id"
            name="selectedUserControl"
            [formControl]="selectedUserControl"></p-radioButton>
        </td>
        <td>{{ u.name }} {{ u.last_name }}</td>
        <td>{{ u.username }}</td>
        <td>{{ u.email || '-' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4">Nessun tecnico trovato per l'azienda selezionata.</td>
      </tr>
    </ng-template>
  </p-table>

  <div class="modal-footer">
    <div class="flex justify-content-between">
      <p-button
        (onClick)="close()"
        icon="pi pi-times"
        [text]="true"
        styleClass="butt red"
        [rounded]="true"></p-button>
      <p-button
        icon="pi pi-check"
        (onClick)="save()"
        styleClass="butt"
        [rounded]="true"></p-button>
    </div>
  </div>
</div>
